/**
 * Floating "Start Calling" button — visible on every public page EXCEPT the
 * homepage and the /dialer page (those screens have the dialer in view).
 *
 * - On `/` (home): hidden, because the dialer is the hero and the FAB would
 *   visually collide with the keypad on mobile.
 * - On `/dialer`: hidden, because the page IS the dialer.
 * - Inside `/app/*`: hidden, because the customer bottom-nav covers it.
 * - Anywhere else (rates, about, contact, faq …): routes to `/dialer`.
 *
 * Stacked above the WhatsApp button — both are pushed clear of the
 * "Made with Emergent" badge that sits in the bottom-right corner of every
 * preview deployment. Coordinates are tuned so the badge never overlaps:
 *   • WhatsApp:  bottom-24 / sm:bottom-28   (96 / 112 px)
 *   • CallFab:   bottom-44 / sm:bottom-48   (176 / 192 px)
 */
import { Link, useLocation } from "react-router-dom";
import { Phone } from "lucide-react";

export default function CallFab() {
  const { pathname } = useLocation();
  if (pathname.startsWith("/app")) return null;
  if (pathname === "/dialer") return null;
  if (pathname === "/") return null;

  return (
    <Link
      to="/dialer"
      data-testid="call-fab"
      aria-label="Open dialer"
      className="fixed bottom-44 right-4 sm:bottom-48 sm:right-6 z-[80] inline-flex items-center justify-center h-14 w-14 rounded-full bg-brand-green hover:bg-brand-greenHover text-white shadow-[0_12px_24px_-8px_rgba(31,139,58,0.6)] active:scale-95 transition"
    >
      <Phone className="h-6 w-6 fill-current" />
      <span className="sr-only">Open dialer</span>
    </Link>
  );
}
